import { MedicalLeaveZlaPdf, MedicalLeaveZlaPdfQuery } from '@dreryk/egabinet-ezla-frontend-api';

import { performCqrsQueryGet } from '@dreryk/command-query-react-common';
import { printDocumentAsPdf } from '@dreryk/react-common';
import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { historicalLeavesTranslationKeys } from '../../../translations';

export const printMedicalLeaveZla = async (documentId: number): Promise<void> => {
   try {
      const documentData = await performCqrsQueryGet<MedicalLeaveZlaPdf>(() => {
         const query = new MedicalLeaveZlaPdfQuery();
         query.documentId = documentId;
         return query;
      });
      await printDocumentAsPdf({
         base64: documentData.document.data,
      });
   } catch {
      dispatchSnackbarNegativeEvent(historicalLeavesTranslationKeys.printError);
   }
};
